// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"402":"5caa95bc","417":"a40d77d6","523":"a350a4ef","586":"f0805b4d","719":"18897117","888":"60652e7e","931":"a350a4ef","962":"9f37c0f7"}[chunkId] + ".chunk.css";
};